import axios from 'axios'
import qs from "qs";

// actions
export const actions = {
    async destroy(_ctx, payload) {
        try {
            await axios.delete('/api/abk-fungsional/' + payload)
        } catch (error) {
            return []
        }
    },
    async update(_ctx, payload) {
        try {
            let data = await axios.patch('/api/abk-fungsional/' + payload.id, qs.stringify(payload.data))
            return data
        } catch (error) {
            return []
        }
    },
    async store(_ctx, payload) {
        try {
            let data = await axios.post('/api/abk-fungsional', qs.stringify(payload))
            return data
        } catch (error) {
            return []
        }
    },
    async index(_ctx, payload) {
        const { data } = await axios.get('/api/abk-fungsional?page=' + payload.page + '&id_instansi=' + payload.data.id_instansi + '&id_unit_kerja=' + payload.data.id_unit_kerja + '&id_jabatan_fungsional=' + payload.data.id_jabatan_fungsional)
        return data
    }
}
